"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryPanel = exports.PrimaryPanel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = require("@site/pattern-library-core/image");
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _headlineLockup = require("@site/pattern-library-core/headline-lockup");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _domainSearch = _interopRequireDefault(require("@site/pattern-library-core/domain-search"));
var _inputBar = _interopRequireDefault(require("@site/pattern-library-core/input-bar"));
var _attribution = _interopRequireDefault(require("./attribution"));
var _tooltip = _interopRequireDefault(require("@site/pattern-library-core/tooltip"));
const HeadlineSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineSection",
  class: "pl-hwew1yk"
});
const ActionSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ActionSection",
  class: "pl-a1idgqy2"
});
const DisclaimerSection = /*#__PURE__*/(0, _react2.styled)(_paragraph.default)({
  name: "DisclaimerSection",
  class: "pl-d1m1hnf"
});
const PanelWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PanelWrapper",
  class: "pl-p1y0rw8c"
});
const PrimaryPanelWrapper = /*#__PURE__*/(0, _react2.styled)(PanelWrapper)({
  name: "PrimaryPanelWrapper",
  class: "pl-p1o9y2lr",
  vars: {
    "p1o9y2lr-0": [({
      portraitBgImg
    }) => portraitBgImg ? `url(${portraitBgImg})` : 'initial'],
    "p1o9y2lr-4": [({
      tabletPortraitBgImg
    }) => tabletPortraitBgImg ? `url(${tabletPortraitBgImg})` : 'initial'],
    "p1o9y2lr-6": [({
      landscapeBgImg
    }) => landscapeBgImg ? `url(${landscapeBgImg})` : 'initial']
  }
});
const PanelContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PanelContent",
  class: "pl-p1i3ucpo"
});
const SecondaryPanelWrapper = /*#__PURE__*/(0, _react2.styled)(PanelWrapper)({
  name: "SecondaryPanelWrapper",
  class: "pl-shxkn32",
  vars: {
    "shxkn32-0": [({
      bgColor
    }) => bgColor ? bgColor : 'initial'],
    "shxkn32-5": [({
      disclaimer
    }) => disclaimer ? `'headline action' 'disc action'` : `'headline action'`]
  }
});

/**
* Panel Base
*
* @param {object} props React props for Panel Base
* @param {string} props.eyebrow Eyebrow
* @param {node} props.heading Heading
* @param {node} props.content Content
* @param {node} props.description Content
* @param {array} props.buttons Buttons
* @param {array} props.ctas Buttons
* @param {node} props.belowButtonsContent Below Buttons Content
* @param {string} props.actionDescription Below Buttons Content
* @param {node} props.disclaimer Disclaimer text
* @param {string} props.actionsLayout Actions layout type
* @returns {React.ReactElement} Panel Base
* @public
*/
// eslint-disable-next-line complexity
const PanelBase = ({
  eyebrow,
  heading,
  content,
  description,
  buttons,
  ctas,
  belowButtonsContent,
  actionDescription,
  disclaimer,
  disclaimerTooltip,
  actionsLayout
}) => {
  const btns = ctas || buttons;
  const text = description || content;
  const btnsDesc = actionDescription || belowButtonsContent;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HeadlineSection, null, eyebrow && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    asType: "title",
    size: 0,
    text: eyebrow,
    tag: "h2"
  }), heading && /*#__PURE__*/_react.default.createElement(_headlineLockup.HeadlineString, {
    heading: heading,
    headlineTag: eyebrow ? 'h3' : 'h2',
    headlineSize: "h3"
  }), text && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    asType: "paragraph",
    size: -2,
    dataCy: "description",
    text: text,
    style: {
      marginBottom: `${_patternLibraryUtils.density['6']}`
    }
  })), /*#__PURE__*/_react.default.createElement(ActionSection, null, btns && /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: actionsLayout,
    ctas: btns
  }), btnsDesc && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    as: "paragraph",
    size: 0,
    text: btnsDesc,
    style: {
      marginBlockStart: `${_patternLibraryUtils.density['6']}`
    }
  })), disclaimer && /*#__PURE__*/_react.default.createElement(DisclaimerSection, {
    asType: "caption",
    size: -2,
    text: disclaimer,
    tooltip: disclaimerTooltip,
    style: {
      marginBlockStart: `${_patternLibraryUtils.density['6']}`
    }
  }));
};

/**
* Render Primary Panel
*
* @param {object} props React props for Primary Panel element
* @param {boolean} props.invert Invert text color
* @param {object} props.portrait Primary Panel's mobile background image URL and alt text
* @param {object} props.tablet Primary Panel's desktop and above background image URL and alt text
* @param {object} props.tabletPortraitBackground Primary Panel's tablet portrait and above background image URL and alt text
* @param {string} props.attribution Attribution text
* @param {string} props.rowPosition Attribution position on mobile & tablet
* @param {string} props.columnPosition Attribution position for laptop and above
* @param {Object} props.browserImage Browser image URL and alt text
* @returns {React.ReactElement} Primary Panel component
* @public
*/
const PrimaryPanel = ({
  invert = false,
  portrait,
  landscape,
  tabletPortraitBackground,
  attribution,
  rowPosition,
  columnPosition,
  browserImage,
  partial,
  ...panelBaseProps
}) => {
  return /*#__PURE__*/_react.default.createElement(PrimaryPanelWrapper, {
    "data-partial": partial || (invert ? 'dark1' : ''),
    portraitBgImg: portrait.url,
    landscapeBgImg: landscape.url,
    tabletPortraitBgImg: (tabletPortraitBackground || portrait)?.url,
    "data-cy": "primary-panel"
  }, /*#__PURE__*/_react.default.createElement(PanelContent, null, /*#__PURE__*/_react.default.createElement(PanelBase, panelBaseProps)), (attribution || browserImage) && /*#__PURE__*/_react.default.createElement(_attribution.default, {
    attribution: attribution,
    rowPosition: rowPosition,
    columnPosition: columnPosition,
    browserImage: browserImage
  }));
};

/**
* Render Secondary Panel
*
* @param {object} props React props for Secondary Panel element
* @param {boolean} props.invert Invert text color
* @param {object} props.backgroundColor Secondary Panel's background color
* @returns {React.ReactElement} Secondary Panel component
* @public
*/
exports.PrimaryPanel = PrimaryPanel;
const SecondaryPanel = ({
  invert = false,
  backgroundColor,
  partial,
  ...panelBaseProps
}) => {
  const {
    disclaimer
  } = panelBaseProps;
  return /*#__PURE__*/_react.default.createElement(SecondaryPanelWrapper, {
    "data-partial": partial || (invert ? 'dark1' : ''),
    bgColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    disclaimer: disclaimer,
    "data-cy": "secondary-panel"
  }, /*#__PURE__*/_react.default.createElement(PanelBase, panelBaseProps));
};
exports.SecondaryPanel = SecondaryPanel;
PanelBase.propTypes = {
  invert: _propTypes.default.bool,
  eyebrow: _propTypes.default.string,
  heading: _propTypes.default.node,
  description: _propTypes.default.string,
  content: _propTypes.default.node,
  ctas: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_index.default), _propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape(_merchButton.NSMerchButton.propTypes), _propTypes.default.shape(_inputBar.default.propTypes), _propTypes.default.shape(_domainSearch.default.propTypes)]))]),
  buttons: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_index.default), _propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape(_merchButton.NSMerchButton.propTypes), _propTypes.default.shape(_inputBar.default.propTypes), _propTypes.default.shape(_domainSearch.default.propTypes)]))]),
  belowButtonsContent: _propTypes.default.node,
  actionDescription: _propTypes.default.string,
  disclaimer: _propTypes.default.node,
  disclaimerTooltip: _propTypes.default.shape(_tooltip.default.propTypes),
  actionsLayout: _propTypes.default.oneOf(['button-set', 'input-bar', 'domain-search', 'es-search', 'none'])
};
PrimaryPanel.propTypes = {
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  portrait: _propTypes.default.shape(_image.imgPropShape),
  landscape: _propTypes.default.shape(_image.imgPropShape),
  tabletPortraitBackground: _propTypes.default.shape(_image.imgPropShape),
  ..._attribution.default.propTypes
};
SecondaryPanel.propTypes = {
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]).isRequired
};